<template>
  <v-card class="mt-8">
    <v-layout class="px-4 py-4">
      <h3>Ratings and Comments</h3>
      <v-spacer></v-spacer>
      <div class="d-flex justify-end align-center">
        <v-skeleton-loader
          v-if="loadingStaff && staff === null"
          style="width: 150px;"
          type="text"
        ></v-skeleton-loader>
        <template v-else>
          <span class="body-2 mr-2" style="margin-top: 2px;">Show to Field Tech in the Field Tech App</span>
          <v-switch
            class="ma-0"
            :true-value="1"
            :false-value="0"
            :loading="loadingStaff || loadingSave"
            hide-details
            @change="saveShowOnFieldTech"
            v-model="showInFieldtechApp"
          ></v-switch>
        </template>
      </div>
    </v-layout>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      loader-height="2"
      :footer-props="{'items-per-page-options': [5, 10, 15, 20, 50]}"
      class="my-sticky-last-column-table"
      mobile-breakpoint="100"
    >
      <template v-slot:item="{item}">
        <tr class="items-body-row">
          <td>
            <span v-if="!no_data.includes(item.job_date)">
              {{ item.job_date }}
            </span>
            <em v-else class="grey--text">No Data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.client_name)">
              {{ item.client_name }}
            </span>
            <em v-else class="grey--text">No Data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.job_id)">
              {{ item.job_id }}
            </span>
            <em v-else class="grey--text">No Data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.rate) && ratings.some(i => i.id === Number(item.rate))">{{ ratings.find(i => i.id === Number(item.rate)).name }}</span>
            <em v-else class="grey--text">No data</em>
          </td>
          <td>
            <span v-if="!no_data.includes(item.comment)">
              {{ item.comment }}
            </span>
            <em v-else class="grey--text">No Data</em>
          </td>
          <td>
            <v-flex style="min-width: 65px;">
              <v-flex
                class="action-link error--text"
                @click="vEmit({ name: 'DeleteRating', data: item })"
                >Delete
                <v-icon size="18" color="error">delete</v-icon>
              </v-flex>
            </v-flex>
          </td>
        </tr>
      </template>
    </v-data-table>
    <delete-rating @done="initialize()"></delete-rating>
  </v-card>
</template>

<script>
import ApiService from "@/common/api.service"
import DeleteRating from "./DeleteRating.vue"
import { mapActions } from 'vuex'

export default {
  name: "StaffRatingsAndComments",
  props: ['staff', 'loadingStaff', 'staffRating'],
  components: {
    DeleteRating
  },
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      items: [],
      averageRate: null,
      countRate: null,
      headers: [
        {
          text: "Date",
          value: "job_date",
          sortable: false
        },
        {
          text: "Client Name",
          value: "client_name",
          sortable: false
        },
        {
          text: "Job ID",
          value: "job_id",
          sortable: false
        },
        {
          text: "Rating",
          value: "rating",
          sortable: false
        },
        {
          text: "Comment",
          value: "comment",
          sortable: false
        },
        {
          text: "Actions",
          sortable: false,
          width: "100px",
          align: "left"
        }
      ],
      loading: false,
      totalItems: 0,
      options: {},
      draw: 0,
      tableData: {
        draw: 0,
        length: 10,
        page: 0,
        column: 0,
        dir: "asc"
      },
      showInFieldtechApp: 0,
      loadingSave: false,
      ratings: [
        { name: '1 - Awful', id: 1 },
        { name: '2 - OK', id: 2 },
        { name: '3 - Good', id: 3 },
        { name: '4 - Great', id: 4 },
        { name: '5 - Awesome', id: 5 }
      ],
      serverValidation: true,
      serverValidationMessage: "Oops something went wrong...",
      server_errors: {}
    }
  },
  mounted () {
    this.initialize()
    this.initializeShowInFieldtechApp()
  },
  methods: {
    ...mapActions(['vEmit']),
    initializeShowInFieldtechApp () {
      if (
        !this.no_data.includes(this.staff) &&
        !this.no_data.includes(this.staff.show_rating_comment)
      ) {
        this.showInFieldtechApp = Number(this.staff.show_rating_comment)
      }
    },
    initialize () {
      this.loading = true
      this.staffRating.loadingRate = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc"

      this.tableData.length = itemsPerPage

      this.tableData.page = page
      this.tableData.draw++
      this.draw = this.tableData.draw
      this.tableData.staff_id = this.$route.params.id

      ApiService.get(`/tips_comments/staff_rating_comments`, this.tableData)
        .then(response => {
          this.items = response.data.ratedClientJobs.data
          this.averageRate = response.data.averageRate
          this.countRate = response.data.countRate
          this.staffRating.averageRate = this.averageRate
          this.staffRating.countRate = this.countRate
          this.draw++
          this.totalItems = response.data.ratedClientJobs.total
          this.loading = false
          this.staffRating.loadingRate = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.staffRating.loadingRate = false
        });
    },
    saveShowOnFieldTech (input) {
      let body = {
        show_rating_comment: input
      }
      this.loadingSave = true
      ApiService.post(`/tips_comments/show_rating_comments/${this.staff.id}`, body)
        .then(response => {
          this.$emit('done')
          this.loadingSave = false
        })
        .catch(error => {
          this.showInFieldtechApp = this.staff.show_rating_comment
          console.log(error);
          this.loadingSave = false
        });
    }
  },
  watch: {
    'staff.show_rating_comment': function(val) {
      this.showInFieldtechApp = val
    },
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    }
  }
}
</script>